import Toggles from "../toggles/Toggles"
import { PLUSMINUS } from "./Product"

const deepCopy = obj => JSON.parse(JSON.stringify(obj))
export default class Price {
	props: any;
	modifiers: any;

	constructor(priceData, modifiers?) {
		this.props = priceData
		if (modifiers) {
			this.modifiers = modifiers
		}
	}

	getProps() {
		return deepCopy(this.props)
	}

	getModel() {
		return this.getProps().product.reference.slice(0, 4)
	}

	isUSA() {
		return this.getProps().product.catalogId == 21
	}

	getRate() {
		return this.getProps().rate.id
	}

	isPlusminus(): boolean {
		const subFamilyId = this.props.product?.subFamilyId
		return subFamilyId === PLUSMINUS.SUBFAMILY_ID || subFamilyId === PLUSMINUS.ESSENTIALS_SUBFAMILY_ID
	}

	getJSON() {
		const sortedModifiers = this.getSortedModifiers()
		const salePrice = this.getSalePrice()

		const priceData = this.getProps()
		if (Toggles.isEnabled("pricesDateFields")) {
			["dateUpdated", "syncedAt", "createdAt", "updatedAt"].forEach(dateType => {
				if (priceData[dateType] && typeof priceData[dateType] === "string") {
					priceData[dateType] = new Date(priceData[dateType])
				}
			})
		}


		return {
			...priceData,
			salePrice,
			sortedModifiers
		}
	}

	getSalePrice(discount?: number) {
		if (Toggles.isEnabled("changePricesCalculation")) {
			const sortedModifiers = this.getSortedModifiers()
			let basePrice = this.getProps().salePrice
			let totalAbsolute = 0;
			let totalPercentage = 0;

			for (const priceModifier of sortedModifiers) {
				let absoluteIncrement = 0;
				if (this.props.product.catalogId === 21 && this.props.rate.id === 12) {
					absoluteIncrement = priceModifier.priceIncrementDollars || 0;
				} else {
					absoluteIncrement = priceModifier.priceIncrement || 0;
				}
				totalAbsolute += absoluteIncrement;

				if (priceModifier.priceIncrementPercent) {
					totalPercentage += priceModifier.priceIncrementPercent;
				}
			}
			if (this.isUSA()) {
				totalPercentage = Math.min(totalPercentage, 20);
			}

			let computedPrice = basePrice + totalAbsolute + (basePrice * totalPercentage / 100); // Diego dió like a tu formula 
			if (discount && discount > 0) {
				computedPrice -= discount;
			}

			if (Toggles.isEnabled("changePricesCalculationWithRounding") && (!Toggles.isEnabled("noRoundPlusminusEssentials") || !this.isPlusminus())) {
				computedPrice = Price.getRoundedSalePrice(Math.ceil(computedPrice));
			}
			return Math.ceil(computedPrice);

		} else {
			const sortedModifiers = this.getSortedModifiers()
			let salePrice = this.getProps().salePrice
			const maxPriceUSA = salePrice * 1.2

			for (const priceModifier of sortedModifiers) {
				if (priceModifier.priceIncrementPercent) {
					salePrice *= (100 + priceModifier.priceIncrementPercent) / 100
				}
				let priceIncrement = this.props.product.catalogId == 21 && this.props.rate.id == 12 ?
					priceModifier.priceIncrementDollars :
					priceModifier.priceIncrement

				if (priceIncrement) {
					salePrice += priceIncrement
				}
			}

			if (this.isUSA() && salePrice > maxPriceUSA) {
				salePrice = maxPriceUSA
			}

			if (!Toggles.isEnabled("noRoundPlusminusEssentials") || !this.isPlusminus()) {
				const resto = salePrice % 5
				if (resto) {
					salePrice += 5 - resto
				}
			}

			return Math.ceil(salePrice) // Evitar errores de coma flotante

		}

	}

	getModifiers() {
		return this.modifiers || []
	}

	getSortedModifiers() {
		return this.getModifiers().sort((a, b) => a.priceEffectOrder - b.priceEffectOrder)
	}
	getReference() {
		return this.getProps()?.product.reference
	}

	static getRoundedSalePrice(salePrice) {
		const resto = salePrice % 5
		if (resto) {
			return salePrice + (5 - resto)
		}
		return salePrice
	}
}